import { Component, OnInit, Input, Output, DoCheck, OnDestroy, EventEmitter, Inject, inject } from '@angular/core';
import { Observable, take, combineLatest, takeUntil, Subject, catchError } from 'rxjs';
import { Router } from '@angular/router';

import { Product } from '../product.model';
import { ProductProduct } from '../product-product.model';
import { ProductComponent } from '../../product-component/product-component.model';
import { ProductComponentService } from '../../product-component/product-component.service';
import { ProductInformationManagementService } from 'src/app/core/product-information-management/product-information-management.service';
import { CvlField } from 'src/app/core/product-information-management/product-management-information-models/cvl-field.models';
import { CatalogService } from '../catalog.service';
import { UtilService } from 'src/app/shared/util.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { GlobalDataService } from 'src/app/core/global-data/global-data.service';
import { PermissionService } from 'src/app/core/permission.service';
import { TranslationManagementService } from 'src/app/core/translation/translate.service';

@Component({
  selector: 'app-item-detail',
  templateUrl: './item-detail.component.html',
  styleUrls: ['./item-detail.component.scss'],
})
export class ItemDetailComponent implements OnInit, OnDestroy {
  private unsubNotifier = new Subject<void>();

  @Input() product: Product = new Product(
    0,
    '0',
    0,
    new ProductProduct(0, 0, [], '', '', '', '', '', '', 0, 0, '', '')
  );
  @Input() quantity: number = 1;
  @Input() canSeePrice: boolean = false;
  @Input() popupMode: boolean = false;
  @Input() caller: string = '';
  @Input() customerProductComponentList: ProductComponent[] = [];
  @Output() toggleIsLoading:EventEmitter<boolean> = new EventEmitter();
  @Output() addToCartClicked: EventEmitter<any> = new EventEmitter();
  @Output() closePopup:EventEmitter<boolean> = new EventEmitter();
  isLoading: boolean = true;
  quantitySelected: number = 1;
  note01: string = "";
  isProductOnRequest = false;
  itemPropertyList: any[] = [];
  items: any[] = [];
  fileteredItems: any[] = [];
  isDisabledAddToCart: boolean = false;
  item: any = null;
  isClientEmploye: boolean = false; 
  listOfAllPossibleFilteringsProperties: string[] = [];
  cvlFieldList: CvlField[] = [];
  imageURI: string = "";
  stockAvailability: string = "";
  itemPrice: number = 0;
  title: string = "";
  productComponentList: ProductComponent[] = [];
  productComponentPrice: number = 0;
  totalPrice: number = 0;
  deductProductComponentFromBudget: boolean = false;

  private translateService = inject(TranslationManagementService);

  constructor(
    private catalogService: CatalogService,
    private utilService: UtilService,
    private pimService: ProductInformationManagementService,
    public globalDataService: GlobalDataService,
    private authService: AuthService,
    private permissionService: PermissionService,
    private router: Router,
    private productComponentService: ProductComponentService
  ) {}

  ngOnInit(): void {
    this.isClientEmploye = this.authService.GetCurrentUser().isClientEmploye;

    this.quantitySelected = this.quantity;

    let mustCheckQtyRemains =this.permissionService.mustHaveProductRestrictions();
    let qtyRemaining: number = 0;
    //par défaut, c'Est pas un produit à la demande...
    this.isProductOnRequest = false;

    //si l'usager doit valider ses quantitées restantes...
    if (mustCheckQtyRemains){
      //on va regarder la quantitée restante pour ce produit
      qtyRemaining = this.globalDataService.getRemainingQuantity(this.product.productId);
      //produit à la demande si zéro ou moins..
      this.isProductOnRequest = qtyRemaining <= 0;
    }

    // assigner variable du catalogue courant
    this.globalDataService.currentCatalog
    .pipe(takeUntil(this.unsubNotifier))
    .subscribe((catalog) => {
      let currentUserGroupHeaderId = catalog.userGroupHeaderId;
      // filtrer les product components pour ce produit
      this.productComponentList = this.productComponentService.getEffectiveProductComponents(this.product.productId, currentUserGroupHeaderId, this.customerProductComponentList);
    });
    
    // deduire les prix des product components si applicable
    this.globalDataService.userGroupRestrictions.pipe(takeUntil(this.unsubNotifier)).subscribe(ugr => {

      // flag pour savoir si on doit déduire les montants des produits composants du budget
      this.deductProductComponentFromBudget = ugr.deductProductComponentFromBudget;

      // trouver les prix des produits composants s'il y en a et qu'on déduit les montant du budget

      if (this.deductProductComponentFromBudget && this.productComponentList && this.productComponentList.length > 0) {
        var fetchPriceIdList = this.productComponentList.filter((x: any) => x.childProductComponentType == 'AddProductItemInNewLine').map((x: any) => x.childProductItemId);
        if (fetchPriceIdList.length > 0) {
          this.globalDataService.getProductComponentPrices(fetchPriceIdList)
            .pipe(
              catchError( (error: any) => {
                this.toggleIsLoading.emit(false);
                this.isLoading = false;
                throw error;
              })
            )
            .pipe(takeUntil(this.unsubNotifier))
            .subscribe((res: any) => {
              // mettre à jour les prix dans la liste des product components
              for (const _item of res) {
                var pc = this.productComponentList.filter((x: any) => x.childProductItemId === _item.productItemId);
                if (pc && pc.length > 0) {
                  for (let i = 0; i < pc.length; i++) {
                    pc[i].price = _item.lastInforCSDPricing;
                  }
                }
              }
              this.productComponentPrice = this.deductProductComponentFromBudget ? this.globalDataService.getProductComponentTotalPrice(this.productComponentList) : 0;
          });   
        }
      }
    });

    // title
    this.title = this.utilService.getPropertyTranslated(this.product.product.productTitleFr, this.product.product.productTitleEn);

    this.listOfAllPossibleFilteringsProperties = this.globalDataService.getListOfAllPossibleFilteringProperties();

    let listOfFilteringProperties: string[] = [];

    // subscribe to multiple observables
    let rawData = this.catalogService.getProductItems(this.product.productId).pipe(take(1));
    let cvlFields = this.pimService.getCvlFields();
    let asyncData = combineLatest([rawData, cvlFields]);
    asyncData
    .pipe(takeUntil(this.unsubNotifier))
    .subscribe( ([rawData, cvlFields]) => {

      this.cvlFieldList = cvlFields;

      let allProperties: string[] = [];
      let productItems: any[] = rawData.productItems;

      // Il faut placer toutes les propriétés de tous les productItems dans le tableau et faire un distinct
      for (const item of productItems) {
        let x = Object.keys(item);
        allProperties = allProperties.concat(x);
      }
      //On fait le distinct
      allProperties = [...new Set(allProperties)];

      //On garde les propriétés si elles sont présentes dans la liste des choix possibles
      let possibleProperties = allProperties.filter( (prop: string) =>
        this.listOfAllPossibleFilteringsProperties.indexOf(prop) !== -1
      );

      // Il faut vérifier si les propriétés sont non nulles dans les items
      for (const prop of possibleProperties) {
        let values: any[] = [];

        for (const item of productItems) {
          values.push(item[prop] ? item[prop] : 'N.A.');
        }
        // distinct values
        values = [...new Set(values)];

        //Si on rentre dans le if alors les valeurs ne sont PAS nulles et on l'ajoute la propriété
        if ((values.length === 1 && values[0] == null) === false) {
          listOfFilteringProperties.push(prop);
          // ajouter a la liste des propriétés qui génère le code html
          let propertyTitles = this.cvlFieldList.find(x => x.safestockPropertyName.toLowerCase() === prop.toLowerCase());
          this.itemPropertyList.push({
            propName: prop,
            nameFr: propertyTitles?.fieldTypeDisplayNameFr, // évite de faire un fetch juste pour le cart
            nameEn: propertyTitles?.fieldTypeDisplayNameEn, // évite de faire un fetch juste pour le cart
            values : values,
            currentValue : (values.length === 1 ? values[0] : null), 
          });
        }

      }

      // bâtir la liste des tous les produit items
      let listOfProductItems: any[] = [];

      for (let i = 0; i < productItems.length; i++) {
        let item = productItems[i];

        let objToPush: any = new Object();
        objToPush.productItemId = item.productItemId;
        objToPush.productItemNumber = item.productItemNumber;
        objToPush.productItemCustomerPrice = 0;
        objToPush.productItemTitleEn = item.productItemTitleEn;
        objToPush.productItemTitleFr = item.productItemTitleFr;
        objToPush.productItemMainImageUrl = item.productItemMainImageUrl;
        objToPush.productItemNCNR = item.productItemNCNR ?? false;

        // ajoute les propriétés filtrables
        listOfFilteringProperties.forEach(propertyKey => {
          objToPush[propertyKey] = item[propertyKey] ? item[propertyKey] : 'N.A.';
        });

        listOfProductItems.push(objToPush);
      }

      //Fail safe en cas d'erreur où il est impossible de distinguer entre les product item items via les filtering properties
      if (listOfProductItems.length > 1 && listOfFilteringProperties.length === 0) {
        let title = "module.catalog.warning-popup.title-error";
        let msg = "module.catalog.warning-popup.msg-failed-product-items";
        this.utilService.alert(title, msg);
        return;
      }

      this.items = listOfProductItems;

      // fetch les prix des produitItems
      let ids: number[] = this.items.map((x: any) => x.productItemId);
      this.globalDataService.getProductItemsPrice(ids)
      .pipe(
        catchError( (error: any) => {
          this.toggleIsLoading.emit(false);
          this.isLoading = false;
          throw error;
        })
      )
      .pipe(takeUntil(this.unsubNotifier))
      .subscribe((res2: any) => {
        for (const _item of res2) {
          this.items.filter((x: any) => x.productItemId === _item.productItemId)[0].productItemCustomerPrice = _item.lastInforCSDPricing;
          this.items.filter((x: any) => x.productItemId === _item.productItemId)[0].inforCSD_StockInfo_NetQuantityAvailable = _item.inforCSD_StockInfo_NetQuantityAvailable;
        }
        this.refreshProductItemInfo();
        this.toggleIsLoading.emit(false);
        this.isLoading = false;
      });

      //Fix pour les produit qui ne contient qu'un seul item
      if (this.items.length === 1) {
        this.item = this.items[0];
      }

      // LOOP toutes les propriétées
      listOfFilteringProperties.forEach((prop: string, index: number) => {
   
        this.fileteredItems.push({
          propName: prop,
          value: null,
        });

        // fetch cvl info pour les descriptions fr/en des propriétés
        this.pimService.getOneCvl(prop)
          .pipe(takeUntil(this.unsubNotifier))
          .subscribe( (_cvlData) => {
            // ajouter le data à itemProperties
            var property = this.itemPropertyList.find(x => x.propName === prop);
            if (property) {
              property.cvlData = _cvlData.cvlData;
              property.values = this.sortArrayOfPropertiesValues(property);
            }
            // si c'est le dernier fetch on va rafraîchir les infos du produit
            if (index === listOfFilteringProperties.length - 1) {
              this.refreshProductItemInfo();
            }
          })
        });

    });
  }

  refreshProductItemInfo() {

    // Vérifier si toutes les propriétés sont sélectionnées, si oui, assigner this.item au produit item sélectionné
    var allPropertiesSelected = true;
    var allItems = [...this.items];
    this.itemPropertyList.forEach((property) => {
      // si on trouve une propriété non sélectionnée, on arrête la recherche
      if (!property.currentValue) {
        allPropertiesSelected = false;
        return;
      }
      else {
        // sinon on filtre sur la propriété courante
        allItems = allItems.filter((x) => x[property.propName] === property.currentValue);
      }
    });

    // si toutes les propriétés sont sélectionnées, on assigne l'item correspondant
    if (allPropertiesSelected) {
      this.item = allItems[0];
      this.isDisabledAddToCart = false;
    }
    else {
      this.item = null;
      this.isDisabledAddToCart = true;
    }

    //s'il y a un problème avec le chargement de prix pour cette item alors on lock le bouton (== impossibilité d'ajouter des produit a prix 0)
    if (this.item && this.item.productItemCustomerPrice === 0) { // productItemCustomerPrice est a zero, pourquoi?
      this.isDisabledAddToCart = true;
    }

    // si produit à la demande; la note est requise
    if (this.isProductOnRequest && this.note01 == '')
      this.isDisabledAddToCart = true;

    // image
    this.imageURI = this.item?.productItemMainImageUrl ?? this.product.product.productMainImageUrl;
    this.imageURI = this.imageURI ? this.imageURI : 'assets/img/image-not-found.png';

    // price
    this.refreshPrice();

    // non stock
    this.refreshStockNonStock();
  }

  ngOnDestroy(): void {
    this.unsubNotifier.next();
    this.unsubNotifier.unsubscribe();
  }

  /*
  * sort des propriétés en ordre d'index
  */ 
  public sortArrayOfPropertiesValues(property: any): string[] { 
    // safety si cvlData est vide
    if (!property.values || !property.cvlData) return property.values;
    // sort en ordre d'index
    property.values.sort((a: string, b: string) => {
      let indexA = property.cvlData.find((x: any) => x.key === a)?.index || 0;
      let indexB = property.cvlData.find((x: any) => x.key === b)?.index || 0;
      return indexA - indexB;
    });
    return property.values;
  }

  /*
  * Event Click sur les boutons de propriétéss
  */
  public propertyButtonClick(event: Event, property: any, propertyValue: string) {
    // set product item value
    let item = this.fileteredItems.filter((p) => p.propName === property.propName)[0];
    item.value = propertyValue;
    // set current value in item property list
    this.itemPropertyList.find((p) => p.propName === property.propName).currentValue = propertyValue;
    // refresh product item info
    this.refreshProductItemInfo();
  }

  public translate(french: string, english: string): string {
    return this.utilService.getPropertyTranslated(french, english);
  }

  /**
   * Ajoute un produit item au cart lorsque le produit item exist et que le prix n'est pas zero
   */
  public addToCart() {
    if (this.item != null && this.item.productItemCustomerPrice > 0) {

      // préparer le liste des propriétés (ajoute les traductions)
      let propertyList = this.itemPropertyList.map(x => { 

        // fetch dans la la liste des propriétés
        var valueTitles = x.cvlData ? x.cvlData.find((y: { key: any; }) => y.key === x.currentValue) : null;
        // traduction de la valeur sélection
        if (!valueTitles) {
          valueTitles = { value: { fr: x.currentValue, en: x.currentValue } };
        }
        // on met le nom de la propriété dans le nom au cas ou on ne trouverait pas la traduction
        let nameFr = x.propName;
        let nameEn = x.propName;
        // traduction du nom de la propriété
        if (x.nameFr) nameFr = x.nameFr;
        if (x.nameEn) nameEn = x.nameEn;

        return { 
          name: x.propName, 
          nameFr: nameFr, 
          nameEn: nameEn,
          value: x.currentValue, 
          valueFr: valueTitles?.value.fr, 
          valueEn: valueTitles?.value.en
        } 
      });

      var addData = {
        productId: this.product.productId,
        productItemId : this.item.productItemId,
        itemPrice: this.item.productItemCustomerPrice,
        imageURL: this.item.productItemMainImageUrl,
        quantity: this.quantitySelected,
        productTitleFr: this.item.productTitleFr,
        productTitleEn: this.item.productTitleEn,
        customerProductNumber: this.item.customerProductNumber, // TODO: TESTER
        productItemNumber: this.item.productItemNumber,
        inforCSD_StockInfo_NetQuantityAvailable: this.item.inforCSD_StockInfo_NetQuantityAvailable,
        note01: this.note01,
        isProductOnRequest: this.isProductOnRequest,
        productItemNCNR: this.item.productItemNCNR ?? false,
        item: this.item,
        listOfProperties: propertyList,
        productComponentList: this.productComponentList,
        productComponentPrice: this.productComponentPrice
      };

      // Ajout en mode CATALOG vs mode ORDER-EDIT
      if (this.caller === 'catalog') {
        // add to cart
        var added = this.globalDataService.addToCart(addData);
        // succès
        if (added) {
          this.utilService.notify('shared.notification.success_product_added', 'success');
          // emit close popup if in popup mode
          this.addToCartClicked.emit(addData);
        }
      }
      else { // this.caller === 'order'
          this.addToCartClicked.emit(addData);
      }
      


      /*
      // legacy code (était dans catalog-list avant)
      // fetch des item details POURQUOI??
      this.globalDataService.getProductList()
        .pipe(takeUntil(this.unsubNotifier))
        .subscribe(productList => {});
      */

    } else {
      // erreur lors de l'ajout au panier
      let tile = 'module.catalog.warning-popup.title'
      let msg = 'module.catalog.warning-popup.msg-no-items-exist'
      this.utilService.alert(tile, msg);
    }
  }

  /*
  public navigateToCart() {
    // close popup if the component is in popup mode
    if (this.popupMode) {
      this.closePopup.emit(true);
    }
    // goto cart
    this.router.navigate(['/cart']);
  }
  */

  /*
   * Rafraîchit l'état de disponibilité en stock/non stock
   */
  public refreshStockNonStock() {
    //Si l'item est défini (donc toute les propriétés sont sélectionnées)
    if (this.item != undefined && this.item != null) {
      if (this.item.inforCSD_StockInfo_NetQuantityAvailable > 0)
        this.stockAvailability = this.translateService.translateKey('module.catalog.productModel.stockAvailability_Stock');
      else
        this.stockAvailability =  this.translateService.translateKey('module.catalog.productModel.stockAvailability_NonStock');
    }
    else //si il manque des propriétés pour identifier l'item (couleur, largeur, etc.)
      this.stockAvailability = 'N/A';
  }

  /*
   * Rafraîchit le prix
   */
  public refreshPrice() {
    // si un produit item est sélectionné on affiche son prix
    if (this.item != undefined && this.item != null) {
      this.itemPrice = this.item.productItemCustomerPrice
    }
    // si aucun item de choisi alors affiche le plus petit prix trouvé ou zero.
    else {
      let prices = this.items.map(x => x.productItemCustomerPrice).sort( (a,b) => a - b );
      if(prices.length < 1) {
        // pas de prix trouvé on affiche zero
        this.itemPrice = 0;
      }
      else {
        // afficher le plus petit prix trouvé
        this.itemPrice = prices[0];
      }
    }  
    // mettre a jour le total
    this.totalPrice =  this.quantitySelected * (this.itemPrice + this.productComponentPrice);
  }

  /*
  * Détermine si la chaîne de caractères est un lien URL
  */
  public IsAnUrlLink(paramValToTest?:string | null):boolean
  {
    if (!paramValToTest || paramValToTest == null || paramValToTest.length < 4)
      return false;

    if (paramValToTest.substring(0,4).toLowerCase() === "http")
      return true

    return false;
  }

  /**
   * force the input field to contain a numeric value that is minimum 1
   */
  public forceMinimumValue() {
    if (this.quantitySelected == null || this.quantitySelected == 0)
      this.quantitySelected = 1;
  }

}
